import styled from "styled-components"
import { TextArea } from 'linkdrop-ui'

export const TextAreaStyled = styled(TextArea)`
  margin-bottom: 54px;

  textarea {
    min-height: 364px;
  }
`